<div class="el-dialog">
  <div class="el-header">
    <div class="el-title-wrap">
      <div class="el-title-icon"><mat-icon>library_add</mat-icon></div>
      <div>
        <h2 class="el-title">Add from task library</h2>
        <div class="el-subtitle">Start with a reusable task and customize it next</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="el-close" [disabled]="saving" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="el-body">
    <div class="el-field">
      <label class="el-label">Library task</label>
      <div class="el-picker">
        <app-templated-task-select [(selectedTask)]="selectedTemplate"></app-templated-task-select>
      </div>
    </div>

    @if (selectedTemplate) {
      <div class="el-preview">
        <div class="el-preview-icon"><mat-icon>task_alt</mat-icon></div>
        <div class="el-preview-copy">
          <strong>{{selectedTemplate.name}}</strong>
          <span>{{selectedTemplate.description || 'Ready to customize in the next step.'}}</span>
        </div>
        <div class="el-preview-meta">
          @if (selectedTemplate.subtasks?.length) {
            <span><mat-icon>checklist</mat-icon>{{selectedTemplate.subtasks.length}}</span>
          }
          @if (selectedTemplate.estimatedTime) {
            <span><mat-icon>schedule</mat-icon>{{selectedTemplate.estimatedTime}} min</span>
          }
        </div>
      </div>
    } @else {
      <div class="el-empty">
        <mat-icon>search</mat-icon>
        Search the task library and choose a starting point.
      </div>
    }
  </div>

  <div class="el-footer">
    <span class="el-footer-note">You can edit every detail before saving</span>
    <div class="el-footer-actions">
      <button mat-button mat-dialog-close class="el-btn-ghost" [disabled]="saving">Cancel</button>
      <button id="template_add_save" type="button" class="el-btn-primary" [disabled]="saving" (click)="continue()">
        @if (saving) {
          <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
        } @else {
          <span>Continue</span>
          <mat-icon>arrow_forward</mat-icon>
        }
      </button>
    </div>
  </div>
</div>
